import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  stockCritico: [],
  totalCount: 0,
}

export const Slice = createSlice({
  name: 'stockCritico',
  initialState,
  reducers: {
    setStockCritico: (state, action) => {
      state.stockCritico = action.payload
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload
    },
  },
})

export const { setStockCritico, setTotalCount } = Slice.actions
export default Slice.reducer
